import GroupIcon from '@mui/icons-material/Group'
import OwnersList from './OwnersList'

export default {
  list: OwnersList,
  icon: GroupIcon,
  recordRepresentation: 'name',
}
